import { useRef } from "react";

export const useInputRef = () => {
    const ref = useRef<HTMLInputElement>(null);

    return ref
}